import React, { Component } from 'react'
import './Breadcrumbs.css';

class Company extends React.Component {
    render() {
        return (
            <div className="breadcrumbsRoot">
                <nav className="breadcrumbsRoot_body1 breadcrumbsRoot_secondaryColor" aria-label="breadcrumb">
                    <ol className="breadcrumbsRoot_ol">
                        <li aria-hidden="true"
                            className="MuiBreadcrumbs-separator">
                            <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path></svg>
                        </li>
                    </ol>
                </nav>
            </div>
        )
    }
}

export default Company;